import React from 'react';
import useSignout from '../../../../hooks/Authentication/useSignout';

//Enhancement: Move "link style" button to it's own component
const buttonStyle = {
  background: 'none',
  border: 'none',
  padding: '0',
  color: '#069',
  textDecoration: 'underline',
  cursor: 'pointer',
};

function Index() {
  const signout = useSignout();
  return (
    <>
      <h1>Login Failed</h1>
      <p>
        An error occured during the login process. Click{' '}
        <button onClick={signout} style={buttonStyle}>
          here
        </button>{' '}
        to return to the sign in page and try again.
        <br />
        If the issue persists, please contact Baltimore Life Agent Relations at (877) 533-2468 for
        more information.Please reach out to Baltimore Life Agent Relations at (877) 533-2468 for
        more information.
      </p>
    </>
  );
}

export { Index };
